<template>
    <div class="mb-3">
        <div class="row">
            <h3 class="text-center">{{title}}</h3>
            <div class="col">
                <div class="mb-3 mt-4">
                    <template  v-for="(label,field) in fieldsToReview">
                        <div class="mb-3" v-if="leadData.hasOwnProperty(field)">
                            <label :for="field" class="form-label">{{ label }}</label>
                            <div class="input-group">
                                <input class="form-control pac-target-input disabled" type="text" disabled readonly :value="leadData[field]">
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-lg-6 offset-lg-3">
                <div class="text-center">
                    <a id="btnNext" class="btn btn-lg w-100 btn-primary" role="button" @click.prevent="handleCorrectData">Yes, everything looks correct!</a>
                </div>
                <div class="text-center mt-3">
                    <a id="btnNext" class="btn btn-xs w-100 btn-outline-secondary" role="button" @click.prevent="handleWrongData">No, I need to make changes</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRefreshResultsStorage } from '@/composables/useRefreshResultsStorage.js';
import { PRODUCT_DISPLAY_NAMES, PRODUCT_ROUTE_SLUGS } from '@/constants/product-mappings.js';
import { postAndReturnData } from '@/utils/api.js';

const props = defineProps({
    uid: {
        type: String,
        required: true,
    },
    selectedProduct: {
        type: String,
        required: false,
    },
});

defineEmits(['confirmDataIsCorrect', 'confirmDataIsWrong']);

const { get: getStoredResults } = useRefreshResultsStorage(props.uid);
const leadData = ref({});

const fieldsToReview = {
    'first_name': 'First Name',
    'last_name': 'Last Name',
    'email': 'Email',
    'cell_phone': 'Phone',
    'address': 'Address',
    'province': 'Province',
    'postal_code': 'Postal Code',
    'dob': 'Year of Birth',
};

const title = computed(() => {
    const productName = PRODUCT_DISPLAY_NAMES[props.selectedProduct] ?? null;

    if (productName) {
        return `Refresh Your ${productName} Offers!`;
    } else {
        return `Refresh Your Offers!`;
    }
});

onMounted(() => {
    // console.log('ReviewData mounted');
    const dataInLocalStorage = getStoredResults();
    // console.log('dataInLocalStorage');
    // console.log(dataInLocalStorage);
    leadData.value = dataInLocalStorage.lead_data ?? {};
});

async function handleCorrectData() {
    const productName = props.selectedProduct ?? 'personal_loan';
    const data = {
        uid: props.uid,
        product_name: ['personal_loan', 'car_loan'].includes(productName) ? productName : 'personal_loan',
    };

    const apiResponse = await postAndReturnData('/portal/refresh-data/prepop', data);

    // console.log('apiResponse');
    // console.log(apiResponse);
    if (apiResponse && apiResponse.hasOwnProperty('status') && apiResponse['status'] === 'success') {
        const redirectToPrepopPage = apiResponse.redirect_url.length > 0 ? apiResponse.redirect_url : '/loan';
        window.location.href = redirectToPrepopPage;
    }
}

function handleWrongData() {
    const url = `/${PRODUCT_ROUTE_SLUGS[props.selectedProduct] ?? 'loan'}`;

    window.open(url, '_blank');
}
</script>
